import Disclaimer from '@acorn-portal/shared/src/components/renewal/disclaimer';
import { Box } from '@mui/material';
import { Formik, Form } from 'formik';
import { useNavigate, useParams } from 'react-router';
import { usePolicy } from '@acorn-portal/shared/src/models/policy-model';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import ActionButtons from '@acorn-portal/shared/src/components/wrapper/action-buttons';
import BackButton from '@acorn-portal/shared/src/components/buttons/BackButton';
import ContinueButton from '@acorn-portal/shared/src/components/buttons/ContinueButton';
import { FormikLogErrors } from '../mta/components/FormikLogErrors';

interface IDisclaimer {
	confirm: boolean;
}

const DisclaimerPage = () => {
	const navigate = useNavigate();
	const { policyToken } = useParams();
	const { fullPolicy } = usePolicy(policyToken ?? null);

	const initialValues: IDisclaimer = {
		confirm: false,
	};

	const handleSubmit = () => {
		navigate(`${ROUTE_PATHS.renewalMakeAChangeSummary}/${policyToken}?policyNumber=${fullPolicy.policyNumber}`);
	};

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				gap: 3,
				marginTop: 2,
			}}
		>
			<Box>
				<Formik validateOnChange validateOnBlur initialValues={initialValues} onSubmit={handleSubmit}>
					{() => {
						return (
							<>
								<FormikLogErrors />
								<Box
									component={Form}
									sx={{
										display: 'grid',
										gap: 3,
										padding: '20px',
										backgroundColor: 'white',
										borderRadius: '10px',
									}}
								>
									<Disclaimer />

									<ActionButtons>
										<Box
											sx={{
												display: 'flex',
												flexDirection: 'row',
												justifyContent: 'space-between',
												gap: '20px',
											}}
										>
											<BackButton onClick={() => navigate(ROUTE_PATHS.policyRenewals)}>Cancel</BackButton>

											<ContinueButton type='submit' onClick={handleSubmit}>
												Confirm
											</ContinueButton>
										</Box>
									</ActionButtons>
								</Box>
							</>
						);
					}}
				</Formik>
			</Box>
		</Box>
	);
};

export default DisclaimerPage;
